module.exports = __webpack_public_path__ + "img/discount.8f3263d3.svg";